module.exports = __webpack_public_path__ + "img/solution1.bdcc538a.jpg";